// extracted by mini-css-extract-plugin
export default {"button":"LoginButton_button__LoT8K","icon":"LoginButton_icon__z3UTX","text":"LoginButton_text__6JC5R"};